module.exports = __webpack_public_path__ + "img/INPRG.13a63685.svg";